import { NgModule } from '@angular/core';
import { InitPageViewComponent } from './init-page-view/init-page-view';
import { MoodFaceComponent } from './mood-face/mood-face';
import {IonicModule} from "ionic-angular";
import { UserContentTextareaComponent } from './user-content-textarea/user-content-textarea';
import { StatsWeightGraphComponent } from './stats-weight-graph/stats-weight-graph';
import {PipesModule} from "../pipes/pipes.module";
import { StatsFoodPyramidCardComponent } from './stats-food-pyramid-card/stats-food-pyramid-card';
import { StatsFoodGraphComponent } from './stats-food-graph/stats-food-graph';
@NgModule({
	declarations: [InitPageViewComponent,
    MoodFaceComponent,
    UserContentTextareaComponent,
    StatsWeightGraphComponent,
    StatsFoodPyramidCardComponent,
    StatsFoodGraphComponent],
	imports: [IonicModule, PipesModule],
	exports: [InitPageViewComponent,
    MoodFaceComponent,
    UserContentTextareaComponent,
    StatsWeightGraphComponent,
    StatsFoodPyramidCardComponent,
    StatsFoodGraphComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts